import React from 'react';
import {Box, TextField, Typography} from '@material-ui/core';
import {IManagementLogFormProps} from './AddNewDataPointForm.types';

export const ManagementLogForm: React.FC<IManagementLogFormProps> = ({
  data,
  onDataChange,
}) => {
  const handleChange = (field: string, value: any) => {
    onDataChange({...data, [field]: value});
  };

  return (
    <>
      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Log Date
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="date"
          value={data.logDate}
          onChange={(e) => handleChange('logDate', e.target.value)}
          InputLabelProps={{shrink: true}}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Activity Type
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="e.g. Fertilization, Irrigation"
          value={data.activityType}
          onChange={(e) => handleChange('activityType', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Fertilizer Type (if applicable)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Enter fertilizer name"
          value={data.fertilizerType}
          onChange={(e) => handleChange('fertilizerType', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Application Rate (kg/ha)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="Enter rate"
          value={data.applicationRateKgha}
          onChange={(e) => handleChange('applicationRateKgha', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Irrigation Frequency
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="e.g. Daily, Twice a week"
          value={data.irrigationFrequency}
          onChange={(e) => handleChange('irrigationFrequency', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Irrigation Volume (Liters)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="Enter volume"
          value={data.irrigationVolume}
          onChange={(e) => handleChange('irrigationVolume', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Water Stress Signs
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Describe any signs of water stress"
          value={data.waterStressSigns}
          onChange={(e) => handleChange('waterStressSigns', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Initial Treatment Actions
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          size="small"
          placeholder="Actions taken based on observations"
          value={data.initialTreatmentActions}
          onChange={(e) =>
            handleChange('initialTreatmentActions', e.target.value)
          }
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>
    </>
  );
};
